var Navigation = {

	elements: {
		burger_btn: $('.burger-btn'),
		modal_overlay: $('.modal-overlay'),
		side_nav: $('.c-side-nav'),
		main_wrapper: $('.o-main-wrapper')
	},

	init: function() {
		Navigation.toggleNavigation();
		Navigation.handleOverlayClick();
	},

	toggleNavigation: function() {
		var item = Navigation.elements;

		item.burger_btn.on('click', function(e){
			e.preventDefault();

			$('html, body').toggleClass('fixed');
			item.side_nav.toggleClass('opened');
			item.main_wrapper.toggleClass('opened');
			item.burger_btn.toggleClass('opened');
		});

	},

	handleOverlayClick: function() {
		var item = Navigation.elements;

		item.modal_overlay.on('click', function(e){
			e.preventDefault();

			$('html, body').removeClass('fixed');
			item.side_nav.removeClass('opened');
			item.main_wrapper.removeClass('opened');
			item.burger_btn.removeClass('opened');
		});
	}

};